export default __webpack_public_path__ + "static/media/ContosoLogo.a51481d9.png";